import CategoryListItem from "discourse/components/category-list-item";

export default CategoryListItem.extend({});
